import React from 'react';
import cn from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';

import { Link } from '..';

import styles from './Modal.module.scss';
import Props from './Modal.props';

const Modal = ({ children, onClose, isOpen = false, className }: Props) => {
  return (
    <>
      <div className={cn(styles.Modal, { [styles.Open]: isOpen })}>
        <div className={styles.Overlay} onClick={onClose} />
        <div className={cn(styles.Content, className)}>
          <Link onClick={onClose} className={styles.CloseIcon}>
            <FontAwesomeIcon icon={faTimes} />
          </Link>
          {children}
        </div>
      </div>
    </>
  );
};

export default Modal;
